<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md8>
        <v-container grid-list-md>
          <v-card class="elevation-12">
            <v-app-bar dark color="primary">
              <v-toolbar-title>{{
                $t("auth.register_company")
              }}</v-toolbar-title>
            </v-app-bar>
            <v-card-text>
              <v-form ref="form">
                <v-layout row wrap>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-combobox
                      v-model="company.name"
                      v-validate="'required|max:50'"
                      class="required-field"
                      :label="$t('users.company_name')"
                      :error-messages="errors.collect('person.company_name')"
                      :items="organisations"
                      item-text="text"
                      item-value="vat"
                      data-vv-name="person.company_name"
                      :search-input.sync="orgNameSearch"
                      @change="updateOrgVat"
                      autocomplete="off"
                    >
                      <template v-slot:append>
                        <span class="d-none">&nbsp;</span>
                      </template>
                      <template v-slot:append-item>
                        <span class="d-none">&nbsp;</span>
                      </template>
                      <template v-slot:item="{ index, item }">
                        {{ item.text }} ({{ item.vat }})
                      </template></v-combobox
                    >
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      v-model="company.vat"
                      v-validate="'required|max:10'"
                      class="required-field"
                      :label="$t('users.company_vat')"
                      :error-messages="errors.collect('person.company_vat')"
                      data-vv-name="person.company_vat"
                      :hint="$t('global.helptext_vat')"
                      persistent-hint
                      @keypress="$keyDown_IntOnly($event)"
                      :append-outer-icon="'sync'"
                      @click:append-outer="searchOrgByVat(company.vat)"
                      autocomplete="off"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      v-model="person.first_name"
                      v-validate="'required|max:50'"
                      class="required-field"
                      :label="$t('users.first_name')"
                      :error-messages="errors.collect('person.first_name')"
                      data-vv-name="person.first_name"
                      autocomplete="off"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      v-model="person.last_name"
                      v-validate="'required|max:50'"
                      class="required-field"
                      :label="$t('users.last_name')"
                      :error-messages="errors.collect('person.last_name')"
                      data-vv-name="person.last_name"
                      autocomplete="off"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm6 xs12>
                    <PhoneInput
                      class="required-field"
                      v-validate="'required|max:20'"
                      :label="$t('users.mobile')"
                      v-model="person.mobile"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          person.mobile =
                            (number && number.significant) || formattedNumber
                          person.mobile_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      data-vv-name="person.mobile"
                      :error-messages="errors.collect('person.mobile')"
                      defaultCountry="NO"
                    ></PhoneInput>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-text-field
                      v-model="user.email"
                      v-validate="'required|max:255'"
                      class="required-field"
                      :label="$t('users.email')"
                      :error-messages="errors.collect('user.email')"
                      data-vv-name="user.email"
                      autocomplete="off"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm6 xs12>
                    <v-dialog
                      ref="dialog"
                      v-model="dob_date_menu"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          name="person.date_of_birth"
                          v-model="computedDateofBirth"
                          :label="$t('persons.date_of_birth')"
                          class="required-field"
                          v-validate="'required|validDate'"
                          :error-messages="
                            errors.collect('person.date_of_birth')
                          "
                          append-icon="event"
                          @click:append="dob_date_menu = true"
                          :hint="'Format: ' + DATE_FORMAT"
                          autocomplete="off"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="person.date_of_birth"
                        first-day-of-week="1"
                        :locale="$locale_bcp47(locale)"
                        :max="
                          moment()
                            .subtract(1, 'days')
                            .format(MYSQL_DATE_FORMAT)
                        "
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="dob_date_menu = false"
                          class="darken-2"
                          >{{ $t("global.ok") }}</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs12 class="text-center">
                    <v-checkbox
                      dense
                      v-model="accept_privacy"
                      v-validate="'required'"
                      class="d-inline-flex"
                    >
                    </v-checkbox>
                    <p class="d-inline-flex va-top privacy-line">
                      {{ $t("auth.privacy_consent_to") }}
                      <a
                        @click="show_policy = !show_policy"
                        class="pl-1 privacy-link"
                        >{{ $t("auth.privacy_notice") }}</a
                      >
                    </p>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-actions class="pa-3">
              <v-spacer></v-spacer>

              <action-button
                @click="validate"
                type="default"
                :text="$t('global.submit')"
                icon=""
                :disabled="!accept_privacy"
                :icon_only_xs="false"
              />
              <action-button
                @click="cancel"
                type="default"
                :text="$t('global.back')"
                icon=""
                :icon_only_xs="false"
              />
            </v-card-actions>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <codePopup
      :key="reRenderCodePopup"
      :show="showCodePopup"
      :uuid="uuid"
      :locale="locale"
      :email="user.email"
      :email_validate_only="validateEmailOnly"
      @callback_codepopup_cancel="callback_codepopup_cancel"
      @callback_codepopup_register="callback_codepopup_register"
    />

    <privacyPolicy
      :show="show_policy"
      :locale="locale"
      @callback_privacy_cancel="show_policy = false"
    />
  </v-container>
</template>

<script>
import { ActionButton } from "@brakomp/ui"

import codePopup from "../partials/CodePopup.vue"
import privacyPolicy from "../partials/Privacy.vue"
import { PhoneInput } from "@brakomp/inputs"

export default {
  name: "register-person",

  components: { ActionButton, PhoneInput, codePopup, privacyPolicy },

  props: ["locale"],

  data() {
    return {
      person: {
        first_name: null,
        last_name: null,
        mobile: null,
        date_of_birth: null,
      },
      user: {
        email: null,
      },
      company: {
        name: null,
        vat: null,
      },

      dob_date_menu: false,

      uuid: "",
      code: "",
      showCodePopup: false,
      password: "",

      new_password: "",
      new_password_retype: "",

      show_policy: false,
      accept_privacy: false,

      reRenderCodePopup: 0,
      validateEmailOnly: false,

      organisations: [],
      orgNameSearch: null,

      dictionary: {
        attributes: {
          "user.email": this.$t("users.email"),
          "user.password": this.$t("users.password"),
          "user.status": this.$t("users.status"),

          "person.first_name": this.$t("users.first_name"),
          "person.middle_name": this.$t("users.middle_name"),
          "person.last_name": this.$t("users.last_name"),
          "person.mobile": this.$t("users.mobile"),
          "person.date_of_birth": this.$t("persons.date_of_birth"),
          "person.comments": this.$t("users.comments"),

          "person.company_name": this.$t("users.company_name"),
          "person.company_vat": this.$t("users.company_vat"),
        },
      },
    }
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  created() {
    let vm = this
    let user = localStorage.getItem("__crrntUser")

    this.uuid = this.$generateUUID()
    this.person.mobile_code = "47"

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    if (user) {
      if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
        vm.$router.push(vm.BACKEND_URL + "/dashboard")
      } else {
        vm.$router.push(vm.BACKEND_URL + "/my")
      }
    }
  },

  watch: {
    orgNameSearch: {
      handler: _.debounce(function(search) {
        if (search) {
          this.searchOrgVatByName(search)
        } else {
          this.organisations = []
        }
      }, 300),
    },
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid)
    },

    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.person.date_of_birth)
      },
      set(val) {
        this.$set(this.person, "date_of_birth", this.$dateFormatSetter(val))
      },
    },
  },

  methods: {
    validate() {
      let vm = this
      this.$validator.validate()

      this.$validator.validateAll().then(() => {
        if (this.isFormValid && this.uuid) {
          axios
            .post(this.API_URL + "auth/validatecompany", {
              email: vm.user.email,
              company_vat: vm.company.vat,
            })
            .then(res => {
              if (res.data.status) {
                let user = res.data.user
                if (user) {
                  this.validateEmailOnly = true
                }

                this.generateCode()
              } else {
                if (res.data.type == "approved") {
                  vm.$awn.alert(this.$t("auth.error_user_already_an_employee"))
                } else if (res.data.type == "pending") {
                  vm.$awn.alert(this.$t("auth.error_user_pending_request"))
                }
              }
            })
            .catch(err => console.log(err))
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },
    generateCode() {
      let vm = this
      this.$validator.validate()

      this.$validator.validateAll().then(() => {
        if (this.isFormValid && this.uuid) {
          axios
            .post(this.API_URL + "auth/generatecode", {
              uuid: this.uuid,
              email: vm.user.email,
              first_name: vm.person.first_name,
              last_name: vm.person.last_name,
            })
            .then(res => {
              if (res.data.status) {
                this.reRenderCodePopup += 1
                this.showCodePopup = true
              }
            })
            .catch(err => console.log(err))
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },
    register() {
      let vm = this
      this.$validator.validate()

      this.$validator.validateAll().then(() => {
        if (this.isFormValid) {
          axios
            .post(this.API_URL + "auth/register/company", {
              type: "company",
              email: vm.user.email,
              uuid: vm.uuid,
              code: vm.code,
              password: vm.password,
              mobile: vm.$formatPhoneNumber(
                vm.person.mobile,
                vm.person.mobile_code,
              ),

              company_vat: vm.company.vat,
              company_name: vm.company.name,

              person: {
                organisation_id: vm.person.organisation_id,
                organisation_name: vm.person.organisation_name,
                first_name: vm.person.first_name,
                middle_name: vm.person.middle_name,
                last_name: vm.person.last_name,
                mobile: vm.$formatPhoneNumber(
                  vm.person.mobile,
                  vm.person.mobile_code,
                ),
                date_of_birth: vm.person.date_of_birth,
              },
            })
            .then(res => {
              if (res.data.status) {
                let user_id = res.data.user_id
                let login_token = res.data.login_token

                // Existing users only get a pending access request; they log in with their own password.
                if (!login_token) {
                  vm.$awn.success(
                    this.$t("auth.register_company_pending_existing_user"),
                  )
                  this.$router.push("/auth/" + this.locale + "/login")
                  return
                }

                vm.$awn.success(this.$t("auth.register_company_pending"))

                // Login user via id
                axios
                  .post(this.API_URL + "auth/loginUser", {
                    id: user_id,
                    token: login_token,
                    type: "auth",
                  })
                  .then(res => {
                    this.postLogin(res.data)
                  })
                  .catch(err => console.log(err))

                //this.$router.push("/auth/" + this.locale + "/login")
              } else if (res.data.type == "approved") {
                vm.$awn.alert(this.$t("auth.error_user_already_an_employee"))
              } else if (res.data.type == "pending") {
                vm.$awn.alert(this.$t("auth.error_user_pending_request"))
              } else {
                vm.$awn.alert(res.data.error)
              }
            })
            .catch(err => {
              console.log(err)
              vm.$awn.alert(vm.$t("auth.register_failed"))
            })
        } else {
          this.$awn.alert(this.$t("global.form_not_valid"))
        }
      })
    },
    postLogin(data) {
      let vm = this
      let token = data.access_token
      let user = data.user_data

      if (token && user) {
        let status = user.status
        let locale = "no"

        this.$cookies.set(`${this.COOKIE_PREFIX}access_token`, token)
        vm.$setAuthorization(token)
        vm.$init(token, user)

        let localesetting = user.settings.find(i => i.key == "locale")
        if (localesetting && localesetting.value) {
          locale = localesetting.value
        }

        this.$updateSetting("fe_locale", locale)
        this.$updateSetting("locale", locale)
        this.$i18n.locale = locale

        if (status == 1) {
          // After login redirects
          if (vm.$hasRole("system-developer") || vm.$hasRole("superuser")) {
            vm.$router.push(vm.BACKEND_URL + "/dashboard")
          } else {
            vm.$router.push(vm.BACKEND_URL + "/my")
          }
        } else if (status == 3) {
          this.$router.push("/auth/" + locale + "/forcechangepassword")
        }
      } else {
        vm.$awn.alert(vm.$t("auth.login_error"))
      }
    },
    cancel() {
      this.$router.push("/auth/" + this.locale + "/login")
    },
    callback_codepopup_register(password, code) {
      this.code = code
      if (password) {
        this.password = password
      }

      this.register()
      this.showCodePopup = false
    },
    callback_codepopup_cancel() {
      this.showCodePopup = false
    },
    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then(res => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer,
            })
            // Automaticlly set the organisation name
            this.$set(this.company, "name", companyname || null)
            this.$set(this.company, "vat", data.organisasjonsnummer || null)
          })
          .catch(function() {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.company, "name", null)
            vm.$set(vm.company, "vat", null)
          })

        // let promise = this.$api1881SearchVAT(search)
        // promise
        //   .then((res) => {
        //     let data = res.data
        //     if (data && data.contacts) {
        //       this.organisations = data.contacts.map((item) => {
        //         return {
        //           key: item.name,
        //           text: item.name,
        //           vat: item.organizationNumber
        //         }
        //       })

        //       this.$set(this.company, "name", this.organisations.length ? this.organisations[0].text : null)
        //       this.$set(this.company, "vat", this.organisations.length ? this.organisations[0].vat : null)
        //     } else {
        //       vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //     }
        //   })
        //   .catch(function(error) {
        //     vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
        //   })
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find(i => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then(res => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter
                  .slice(0, 3)
                  .map(item => {
                    let companyname = this.$formatAPICompanyName(item.navn)
                    return {
                      key: companyname,
                      text: companyname,
                      vat: item.organisasjonsnummer,
                    }
                  })
              }
            })
            .catch(function() {})
        }

        // let promise = this.$api1881SearchName(search)
        // promise.then((res) => {
        //   let data = res.data
        //   if (data && data.contacts) {
        //     this.organisations = data.contacts.map((item) => {
        //       return {
        //         key: item.name,
        //         text: item.name,
        //         vat: item.organizationNumber
        //       }
        //     })
        //   }
        // })
      }
    },
    updateOrgVat() {
      if (this.company.name && typeof this.company.name === "object") {
        let org = this.organisations.find(i => i.key == this.company.name.key)
        if (org) {
          this.$set(this.company, "name", org.text || null)
          this.$set(this.company, "vat", org.vat || null)
          return
        }

        // let org = this.organisations.find((i) => i.vat == this.company.name.vat)
        // if (org) {
        //   this.$set(this.company, "name", org.text)
        //   this.$set(this.company, "vat", org.vat)
        //   return
        // }
      }

      this.$set(this.company, "name", this.company.name || null)
      this.$set(this.company, "vat", null)
    },
    phoneNoSpace() {
      if (this.person.mobile) {
        this.person.mobile = this.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find(
          i => i.field == "person.mobile" && i.rule == "no_space",
        )
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
  },
}
</script>
